module.exports = __webpack_public_path__ + "static/media/tech rider dance example 1.ceebadcc.docx";